import { gql } from '@apollo/client'

export const DELETE_SHIUR_FROM_HISTORY = gql`
  mutation deleteShiurFromHistory($shiurId: String!) {
    deleteShiurFromHistory(shiurId: $shiurId)
  }
`
